import clsx from 'clsx';
import Enllac from 'components/3cat/Enllac';
import __isEmpty from 'lodash/isEmpty';
import Image from 'next/image';
import 'swiper/css';
import 'swiper/css/free-mode';
import { dataResources } from 'utils/constants';
import styles from './menuError.module.scss';

const { basePath } = dataResources;

const imageLoader = ({ src }) => {
    return `${src}`;
};

export default function Menu(props) {
    const stylesMenu = clsx({
        [styles.menu]: true
    });

    const stylesMenuWrapper = clsx({
        [styles.menuWrapper]: true
    });

    const stylesLogo = clsx({
        [styles.logo]: true
    });

    return (
        <>
            <div className={stylesMenu} data-testid='menu'>
                <div className={stylesMenuWrapper}>
                    <Enllac href='/3cat'>
                        <div className={stylesLogo}>
                            <Image
                                loader={imageLoader}
                                unoptimized={true}
                                width={111}
                                height={32}
                                alt='Logo 3Cat'
                                src={basePath + '/_resources/logos/3cat_color.svg?v=2.2512.2'}
                            />
                        </div>
                    </Enllac>
                </div>
            </div>
        </>
    );
}
